import { PROPERTY_GRID_SUBJECT_PROPERTY } from '@aloft/toolkit-shared';
import { Typography, TypographyProps } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { PropertyGridFieldName, PropertyGridForm } from '../types.ts';
import { readOnlyFieldTypographyProps } from './consts.ts';
import { PropertyGridFieldProps } from './types.ts';

export const ReadOnlyField = ({
  columnIndex,
  field,
  colSpan = 1,
  isArv = false,
  control,
  getValues,
}: PropertyGridFieldProps) => {
  const { fieldName: rawFieldName, toDisplayValue } = field;

  const propertyId = getValues(`columns.${columnIndex}.propertyId`);
  const isSubject = propertyId === PROPERTY_GRID_SUBJECT_PROPERTY;

  const arvFieldName = (rawFieldName as string).replace(
    /^editableData\./,
    'editableData.arv.',
  ) as PropertyGridFieldName;
  const fieldName = isSubject && isArv ? arvFieldName : rawFieldName;

  const propertyDataFieldName: FieldPath<PropertyGridForm> = `columns.${columnIndex}.propertyData.${fieldName}`;
  const value = useWatch({ control, name: propertyDataFieldName }) as string | undefined;
  const displayValue = toDisplayValue ? toDisplayValue(value, propertyId) : value;

  const typographyProps: TypographyProps = {
    ...readOnlyFieldTypographyProps,
    __dangerDoNotUseSx: {
      ...readOnlyFieldTypographyProps.__dangerDoNotUseSx,
      gridColumn: `span ${colSpan}`,
    },
  };

  return <Typography {...typographyProps}>{displayValue}</Typography>;
};
